export default "__VITE_ASSET__BXPQWma2__"